import React from 'react';
import styled, { x, css } from '@xstyled/styled-components';
import { LlamaModal } from '~/ui/llama-modal/LlamaModal';
import closeNavAudio from '~/assets/mp3/close_nav.mp3';
import WrongAnswerAudio from '~/assets/mp3/wrong_answer.mp3';
import RightAnswerAudio from '~/assets/mp3/right_answer.mp3';
import { useQuizOrderStore } from '../QuizOrderStore';
import { useAudioEffect } from '~/ui/audio-effect/useAudioEffect';
import { t } from 'ttag';

const ModalWrapper = styled.div`
  padding: 55px 90px;
  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
    margin-bottom: 48px;
    font-size: 36px;
    font-family: var(--llama-font);
  }
`;

const StyledButton = styled.buttonBox<{ outlined?: boolean }>`
  padding: 15px 50px;
  font-family: ${p => p.theme.fonts.title};
  font-weight: 700;
  font-size: 16px;

  ${p =>
    p.outlined
      ? css`
          background-color: transparent;
          color: ${p.theme.colors.accentDark};
          border-radius: 10px;
          border: 3px solid ${p.theme.colors.accentDark};
        `
      : css`
          background-color: ${p.theme.colors.accentDark};
          color: #ffffff;
          border-radius: 10px;
        `}
`;

export const ConfirmationPopup = ({
  setIsOpened
}: {
  setIsOpened: (state: boolean) => void;
}) => {
  const { handleCheckAnswers, setPopupWasOpened } = useQuizOrderStore();
  const [playCloseAudioEffect] = useAudioEffect(closeNavAudio);
  const [playWrongAnswerAudioEffect] = useAudioEffect(WrongAnswerAudio);
  const [playRightAnswerAudioEffect] = useAudioEffect(RightAnswerAudio);

  const handleAnswer = () => {
    setIsOpened(false);
    setPopupWasOpened(true);
    handleCheckAnswers(playWrongAnswerAudioEffect, playRightAnswerAudioEffect);
  };

  const handleClosePopup = () => {
    setIsOpened(false);
    playCloseAudioEffect();
  };

  return (
    <>
      <x.div
        position="absolute"
        top={0}
        left={0}
        minHeight="100vh"
        minWidth="100vw"
        background="black"
        opacity="0.8"
        onClick={handleClosePopup}
      />
      <LlamaModal>
        <ModalWrapper>
          <x.h2>{t`Are you sure?`}</x.h2>
          <x.div display="flex" justifyContent="space-between" gap={16}>
            <StyledButton outlined={true} onClick={handleClosePopup}>
              {t`No`}
            </StyledButton>
            <StyledButton onClick={handleAnswer}>{t`Yes`}</StyledButton>
          </x.div>
        </ModalWrapper>
      </LlamaModal>
    </>
  );
};
